module.exports = __webpack_public_path__ + "static/media/29BDOS14.42a148c8.jpg";